//
export default {

  /**
   * 
   */
  toList() {
    return [
      {
        text    : "Folio",
        value   : "invoice_number",
      },
      {
        text    : "rut",
        format  : "rut",
        value   : "pch_provider_rut",
      },
      {
        text    : "proveedor",
        value   : "pch_provider_alias_name",
        component: {
          custom: 'pch_provider_id',
          type: 'link',
          props: {
            mapper: value => ({
              name: 'provider-update',
              params: {
                id: value,
              },
            }),
            tooltip: 'Detalle proveedor',
          },
        },
      },
      {
        text    : "fecha de emisión",
        align   : "right",
        format  : "datetime",
        value   : "emission_date",
      },
      {
        text    : "Neto",
        align   : "right",
        format  : "currency",
        value   : "new_subtotal",
      },
      {
        text    : "IVA",
        align   : "right",
        format  : "currency",
        value   : "iva",
      },
      {
        text    : "Total",
        align   : "right",
        format  : "currency",
        value   : "total",
      },
      {
        text    : "Condición de pago", 
        align   : "center",
        value   : "pch_payment_condition_type",
      }
    ]
  }
}